import CloseIcon from '@mui/icons-material/Close';
import { Box, Divider, IconButton, Typography, useTheme } from '@mui/material';
import React from 'react';
import { AIStore } from 'services/store/ai';
import ArticleImage from './ArticleImage';
import Tips from './Tips';

type TabPanelProps = {
  children: React.ReactNode;
  value: number;
  index: number;
};

const TabPanel = ({ children, value, index, ...other }: TabPanelProps) => {
  const theme = useTheme();

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
      sx={{
        maxHeight: theme.spacing(60),
        overflowY: 'auto',
        pb: theme.spacing(3),
      }}
    >
      {value === index && <Box sx={{ p: theme.spacing(3) }}>{children}</Box>}
    </Box>
  );
};

type ArticlePropsType = {
  data: AIStore['infoGuide'];
  gridArea: string;
  value: number;
  open: boolean;
  setOpen: (open: boolean) => void;
};

const GuideArticle = ({
  data,
  gridArea,
  value,
  open,
  setOpen,
}: ArticlePropsType) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        gridArea,
        position: 'relative',
        bgcolor: theme.palette.grey[50],
        color: theme.palette.grey[900],
        borderTopRightRadius: theme.spacing(1),
        borderBottomRightRadius: theme.spacing(1),
      }}
    >
      <Box
        sx={{
          py: theme.spacing(1.5),
          position: 'relative',
          display: 'flex',
          justifyContent: 'flex-end',
        }}
      >
        <IconButton
          sx={{
            mr: theme.spacing(3),
            color: theme.palette.grey[600],
          }}
          size="medium"
          aria-controls={open ? 'account-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={() => setOpen(!open)}
        >
          <CloseIcon />
        </IconButton>
      </Box>
      <Divider sx={{ borderColor: theme.palette.grey[100] }} />
      {data?.map((article) => (
        <TabPanel value={value} index={article.index} key={article.title}>
          <Typography variant="h4" sx={{ mb: theme.spacing(3), fontSize: 24 }}>
            {article.title}
          </Typography>
          {article?.primaryImage && (
            <ArticleImage
              imageOne={article.primaryImage}
              imageTwo={article.secondaryImage}
              altOne={article.altPrimary}
              altTwo={article.altSecondary}
            />
          )}
          <Typography
            variant="body1"
            dangerouslySetInnerHTML={{ __html: article.description }}
          />
          {article?.secondaryDescription && (
            <Typography
              variant="body1"
              mt={2}
              dangerouslySetInnerHTML={{ __html: article.secondaryDescription }}
            />
          )}
          {article?.tip && <Tips tip={article.tip} />}
        </TabPanel>
      ))}
    </Box>
  );
};
export default GuideArticle;
